import React, { useState } from "react"; // Asegúrate de importar useState
import { Link } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AGIndustries from "./components/AGIndustries/AGIndustries";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";

/*Al seleccionar alguna imagen , redirige ala pestaña y lo que hace esta funcion es llevarte
hasta el inicio de la pestaña sin el te manda hasta abajo*/
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Componente temporal para el Editor
const EditorPage = () => (
  <div
    style={{
      padding: "50px",
      backgroundColor: "#000",
      color: "#fff",
      minHeight: "100vh",
      fontFamily: "sans-serif",
    }}
  >
    <h1 style={{ borderBottom: "1px solid #333", paddingBottom: "10px" }}>
      PANEL DE EDICIÓN
    </h1>
    <p>
      Desde aquí podrás ingresar nuevos códigos o textos para el apartado de
      Marte.
    </p>
    <textarea
      style={{
        width: "100%",
        height: "300px",
        backgroundColor: "#1a1a1a",
        color: "#00ff00",
        padding: "15px",
        border: "1px solid #333",
      }}
      placeholder="Escribe el nuevo contenido aquí..."
    />
    <br />
    <button
      style={{
        marginTop: "20px",
        padding: "10px 25px",
        backgroundColor: "#fff",
        color: "#000",
        border: "none",
        cursor: "pointer",
        fontWeight: "bold",
      }}
    >
      GUARDAR CAMBIOS
    </button>
  </div>
);

const Cartelera = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [animar, setAnimar] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuActivo, setMenuActivo] = useState(null);
  const cerrar = () => setMenuAbierto(false);

  const ejecutarAnimacionYLink = (url) => {
    setAnimar(true);
    setTimeout(() => {
      window.location.href = url;
    }, 800);
  };

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`sx-cartelera-page ${animar ? "efecto-salida" : ""}`}>
      <nav className={`sx-nav-cartelera ${scrolled ? "scrolled" : ""}`}>
        <div className="cartier-header-main">
          <div className="cartier-logo-container">
            <Link to="/">
              <img
                src="/LogoHeader.png"
                alt="Cartier"
                className="cartier-logo-img"
              />
            </Link>
          </div>
          <Link to="/" className="sx-back-btn">
            ←
          </Link>
        </div>

        <div className="sx-nav-content">
          <div className={`sx-side-menu ${menuAbierto ? "is-open" : ""}`}>
            <Link to="/cartelera" onClick={cerrar}>
              Cartelera
            </Link>
            <Link to="/sponsors" onClick={cerrar}>
              Sponsors
            </Link>
            <Link to="/accesorios" onClick={cerrar}>
              Accesorios
            </Link>
            <Link to="/experiencias" onClick={cerrar}>
              Experiencias
            </Link>
          </div>

          <div className="sx-menu">
            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("cartelera")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/cartelera" onClick={cerrar}>
                Cartelera
                <span
                  className={`sx-arrow ${
                    menuActivo === "cartelera" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${menuActivo === "cartelera" ? "show" : ""}`}
              >
                {/* El video de fondo */}
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="sx-dropdown-video"
                >
                  <source src="/Cartelera_Fondo.mp4" type="video/mp4" />
                  Tu navegador no soporta videos.
                </video>
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/sponsors" onClick={cerrar}>
                Sponsors
                <span
                  className={`sx-arrow ${
                    menuActivo === "sponsors" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "sponsors" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container sx-ocultar-movil"
              onMouseEnter={() => setMenuActivo("inicio")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/inicio" onClick={cerrar}>
                Inicio
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "inicio" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/accesorios" onClick={cerrar}>
                Accesorios
                <span
                  className={`sx-arrow ${
                    menuActivo === "accesorios" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "accesorios" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("experiencias")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/experiencias" onClick={cerrar}>
                Experiencias
                <span
                  className={`sx-arrow ${
                    menuActivo === "experiencias" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "experiencias" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>
          </div>

          <div className="sx-nav-right"></div>
        </div>
      </nav>

      {/* VIDEO FIJO DE FONDO — fuera del scroll container para que sea parallax */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="sx-background-video"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source src="/Cartelera_Fondo.mp4" type="video/mp4" />
      </video>

      {/* OVERLAY OSCURO FIJO */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",

          zIndex: 1,
        }}
      />

      <div style={{ position: "relative", zIndex: 10 }}>
        {/* ══ SECCIÓN 1 — Grid fila 1 */}
        <section className="sx-section-first"
          style={{
            height: "100vh",
            scrollSnapAlign: "start",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            padding: "250px 2rem 2rem 2rem",
          }}
        >
          <div className="sx-gallery-grid-3">
            <div className="sx-item">
              <img src="/Cartelera1.jpeg" alt="Santos 1" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
            <div className="sx-item">
              <img src="/Cartelera2.jpeg" alt="Santos 2" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
            <div className="sx-item">
              <img src="/Cartelera3.jpeg" alt="Santos 3" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
          </div>
        </section>

        {/* ══ SECCIÓN 2 — Grid fila 2 */}
        <section
          style={{
            height: "100vh",
            scrollSnapAlign: "start",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "130px 2rem 2rem 2rem",
          }}
        >
          <div className="sx-gallery-grid-3">
            <div className="sx-item">
              <img src="/Seccion2.1.jpeg" alt="Santos 1" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
            <div className="sx-item">
              <img src="/Seccion2.2.jpeg" alt="Santos 2" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
            <div className="sx-item">
              <img src="/Seccion2.3.jpeg" alt="Santos 3" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
          </div>
        </section>

        {/* ══ SECCIÓN 3 — Grid fila 3 */}
        <section
          style={{
            height: "100vh",
            scrollSnapAlign: "start",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 2rem 2rem 2rem",
          }}
        >
          <div className="sx-gallery-grid-3">
            <div className="sx-item">
              <img src="/Seccion3.1.jpeg" alt="Santos 1" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
            <div className="sx-item">
              <img src="/Seccion3.2.jpeg" alt="Santos 2" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
            <div className="sx-item">
              <img src="/Seccion3.3.jpeg" alt="Santos 3" />
              <div className="sx-item-info">
                <h3>EDICIÓN 2023</h3>
              </div>
            </div>
          </div>
        </section>
        <footer className="sx-footer">
          <div className="sx-footer-content">
            <span className="sx-copyright">
              Todo material y recursos fotográficos utilizados son propiedad
              exclusiva del Festival VV, MARCA REGISTRADA, queda prohibido su
              uso y descarga para otros fines de lucro, promoción y divulgación
              bajo responsabilidad legal.
            </span>
            <span className="sx-copyright">
              Festival VV — © Todos los derechos reservados.
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
};

const Sponsors = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [animar, setAnimar] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuActivo, setMenuActivo] = useState(null);
  const cerrar = () => setMenuAbierto(false);

  const ejecutarAnimacionYLink = (url) => {
    setAnimar(true);
    setTimeout(() => {
      window.location.href = url;
    }, 800);
  };

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`sx-sponsors-page ${animar ? "efecto-salida" : ""}`}>
      <nav className={`sx-nav ${scrolled ? "scrolled" : ""}`}>
        <div className="cartier-header-main">
          <div className="cartier-logo-container">
            <Link to="/">
              <img
                src="/LogoHeader.png"
                alt="Cartier"
                className="cartier-logo-img"
              />
            </Link>
          </div>
          <Link to="/" className="sx-back-btn">
            ←
          </Link>
        </div>

        <div className="sx-nav-content">
          <div className={`sx-side-menu ${menuAbierto ? "is-open" : ""}`}>
            <Link to="/cartelera" onClick={cerrar}>
              Cartelera
            </Link>
            <Link to="/sponsors" onClick={cerrar}>
              Sponsors
            </Link>
            <Link to="/accesorios" onClick={cerrar}>
              Accesorios
            </Link>
            <Link to="/experiencias" onClick={cerrar}>
              Experiencias
            </Link>
          </div>

          <div className="sx-menu">
            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("cartelera")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/cartelera" onClick={cerrar}>
                Cartelera
                <span
                  className={`sx-arrow ${
                    menuActivo === "cartelera" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${menuActivo === "cartelera" ? "show" : ""}`}
              >
                {/* El video de fondo */}
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="sx-dropdown-video"
                >
                  <source src="/Cartelera_Fondo.mp4" type="video/mp4" />
                  Tu navegador no soporta videos.
                </video>
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/sponsors" onClick={cerrar}>
                Sponsors
                <span
                  className={`sx-arrow ${
                    menuActivo === "sponsors" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "sponsors" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container sx-ocultar-movil"
              onMouseEnter={() => setMenuActivo("inicio")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/inicio" onClick={cerrar}>
                Inicio
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "inicio" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/accesorios" onClick={cerrar}>
                Accesorios
                <span
                  className={`sx-arrow ${
                    menuActivo === "accesorios" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "accesorios" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("experiencias")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/experiencias" onClick={cerrar}>
                Experiencias
                <span
                  className={`sx-arrow ${
                    menuActivo === "experiencias" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "experiencias" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>
          </div>

          <div className="sx-nav-right"></div>
        </div>
      </nav>
      <div className="sx-spacer" />
      <div
        style={{
          minHeight: "100vh",

          fontFamily: "sans-serif",
        }}
      >
        {/* ══ SECCIÓN 1 ══ */}
        <section>
          <div className="sx-gallery-grid sx-gallery-grid--sponsors">
            <div className="sx-item">
              <img src="/Sponsors_Secc1_img1.jpeg" alt="" />
              <div className="sx-item-info">
                <h3>SPONSOR NIVEL 1 </h3>
                <p>
                  Obtienen una carpa de 3x3 + stand Hospitality personalizado en
                  materiales únicos de 3x3 + salas lounge y piso firme, duela o
                  alfombra sobre el campo, acordonado e iluminado por leds,
                  intervenciones artisticas por The AG Gallery presencia en
                  black carpet y 10 accesos VIP.
                </p>
                <span className="sx-price">CONTACTAR</span>
              </div>
            </div>

            <div className="sx-item">
              <img src="/Sponsors_Secc1_img2.jpeg" alt="" />
              <div className="sx-item-info">
                <h3>CARPA PREFERENCIAL</h3>
                <p>
                  Carpa con espacio generoso, 2 mesas de apoyo de 2x50 metros y
                  por supuesto, carpa propia de 3x3 metros, ventaja de locación
                  para venta de bebidas o alimentos, presencia en la black
                  carpet del evento oficial y 5 accesos VIP.
                </p>
                <span className="sx-price">$20,000.00 MXN</span>
              </div>
            </div>
          </div>
        </section>

        <div className="sx-spacer" />

        {/* ══ SECCIÓN 2 ══ */}
        <section>
          <div className="sx-gallery-grid sx-gallery-grid--sponsors">
            <div className="sx-item">
              <img src="/Carpa_Clasica.jpeg" alt="" />
              <div className="sx-item-info">
                <h3>CARPA CLÁSICA </h3>
                <p>
                  Exclusivamente para pymes o artesanos, quienes podrán tener un
                  espacio en carpas instaladas en túnel para protegerse de los
                  rayos del sol o inclemencias del tiempo, más iluminación y una
                  mesa de apoyo de 2 x 50 metros en túnel.
                </p>
                <span className="sx-price">$5,000.00 MXN</span>
              </div>
            </div>

            {/* ══ ENCUESTA / REGISTRO ══ */}
            <div className="sx-registro">
              <h2>Contáctanos</h2>
              <p>Envía tu propuesta como sponsor.</p>

              <div className="sx-registro-fila">
                <input type="text" placeholder="Nombre" />
                <input type="text" placeholder="Apellido" />
              </div>

              <input type="email" placeholder="Correo electrónico" />
              <input type="tel" placeholder="Número de teléfono" />

              <div className="sx-registro-fila">
                <input type="text" placeholder="Ciudad" />
              </div>

              <select>
                <option value="">¿Cómo nos conociste?</option>
                <option value="redes">Redes sociales</option>
                <option value="amigo">Recomendación de un amigo</option>
                <option value="evento">En un evento</option>
                <option value="otro">Otro</option>
              </select>

              <select>
                <option value="">¿Cuál sería tu propuesta?</option>
                <option value="relojes">Sponsor nivel 1</option>
                <option value="pulseras">Carpa preferencial</option>
                <option value="anillos">Carpa Clásica</option>
                <option value="anillos">Alianza Comercial</option>
              </select>

              <textarea
                placeholder="¿Algún comentario o solicitud especial?"
                rows="3"
              />

              <button>ENVIAR</button>
            </div>
          </div>
        </section>

        <div className="sx-spacer" />

        {/* ══ FOOTER ══ */}
        <footer className="sx-footer">
          <div className="sx-footer-content">
            <span className="sx-copyright">
              Todo material y recursos fotográficos utilizados son propiedad
              exclusiva del Festival VV, MARCA REGISTRADA, queda prohibido su
              uso y descarga para otros fines de lucro, promoción y divulgación
              bajo responsabilidad legal.
            </span>
            <span className="sx-copyright">
              Festival VV — © Todos los derechos reservados.
            </span>
          </div>
        </footer>
      </div>{" "}
      {/* ← cierre del div principal */}
    </div>
  );
};

const Accesorios = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [animar, setAnimar] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuActivo, setMenuActivo] = useState(null);
  const cerrar = () => setMenuAbierto(false);

  const ejecutarAnimacionYLink = (url) => {
    setAnimar(true);
    setTimeout(() => {
      window.location.href = url;
    }, 800);
  };

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`sx-accesorios-page ${animar ? "efecto-salida" : ""}`}>
      <nav className={`sx-nav ${scrolled ? "scrolled" : ""}`}>
        <div className="cartier-header-main">
          <div className="cartier-logo-container">
            <Link to="/">
              <img
                src="/LogoHeader.png"
                alt="Cartier"
                className="cartier-logo-img"
              />
            </Link>
          </div>
          <Link to="/" className="sx-back-btn">
            ←
          </Link>
        </div>

        <div className="sx-nav-content">
          <div className={`sx-side-menu ${menuAbierto ? "is-open" : ""}`}>
            <Link to="/cartelera" onClick={cerrar}>
              Cartelera
            </Link>
            <Link to="/sponsors" onClick={cerrar}>
              Sponsors
            </Link>
            <Link to="/accesorios" onClick={cerrar}>
              Accesorios
            </Link>
            <Link to="/experiencias" onClick={cerrar}>
              Experiencias
            </Link>
          </div>

          <div className="sx-menu">
            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("cartelera")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/cartelera" onClick={cerrar}>
                Cartelera
                <span
                  className={`sx-arrow ${
                    menuActivo === "cartelera" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${menuActivo === "cartelera" ? "show" : ""}`}
              >
                {/* El video de fondo */}
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="sx-dropdown-video"
                >
                  <source src="/Cartelera_Fondo.mp4" type="video/mp4" />
                  Tu navegador no soporta videos.
                </video>
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/sponsors" onClick={cerrar}>
                Sponsors
                <span
                  className={`sx-arrow ${
                    menuActivo === "sponsors" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "sponsors" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container sx-ocultar-movil"
              onMouseEnter={() => setMenuActivo("inicio")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/inicio" onClick={cerrar}>
                Inicio
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "inicio" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/accesorios" onClick={cerrar}>
                Accesorios
                <span
                  className={`sx-arrow ${
                    menuActivo === "accesorios" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "accesorios" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("experiencias")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/experiencias" onClick={cerrar}>
                Experiencias
                <span
                  className={`sx-arrow ${
                    menuActivo === "experiencias" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "experiencias" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>
          </div>

          <div className="sx-nav-right"></div>
        </div>
      </nav>

      {/* ══ SECCIÓN 1: ROPA ══ */}
      <section className="sx-product-catalog ">
        <div className="sx-catalog-grid">
          {/* Producto 1 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/imagen7.jpeg" alt="Producto 1" />
            </div>
            <div className="sx-catalog-info">
              <h3>HOODIE WHITE VV</h3>
              <p>Algodón, grabado en negro.</p>
              <span className="sx-price">$900.00 MXN</span>
            </div>
          </div>

          {/* Producto 2 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/imagen10.jpeg" alt="Producto 2" />
            </div>
            <div className="sx-catalog-info">
              <h3>HOODIE YELLOW PRINT</h3>
              <p>Algodón, grabado en negro.</p>
              <span className="sx-price">$900.00 MXN</span>
            </div>
          </div>

          {/* Producto 3 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/imagen9.jpeg" alt="Producto 3" />
            </div>
            <div className="sx-catalog-info">
              <h3>HOODIE FESTIVAL VV</h3>
              <p>Algodón, grabado clásico.</p>
              <span className="sx-price">$700.00 MXN</span>
            </div>
          </div>

          {/* Producto 4 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/imagen8.jpeg" alt="Producto 4" />
            </div>
            <div className="sx-catalog-info">
              <h3>SECRET BAG VV </h3>
              <p>Bolsa secreta, limitadas.</p>
              <span className="sx-price">$500.00 MXN</span>
            </div>
          </div>
        </div>
      </section>

      {/* ══ SECCIÓN 2: ALIMENTOS ══ */}
      <section className="sx-product-catalog">
        <div className="sx-catalog-grid">
          {/* Producto 1 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion2_1.jpeg" alt="Producto 1" />
            </div>
            <div className="sx-catalog-info">
              <h3>CEREAL AG</h3>
              <p>Cereal chocolate purpura, 250 g.</p>
              <span className="sx-price">NO DISPONIBLE </span>
            </div>
          </div>

          {/* Producto 2 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion2_2.jpeg" alt="Producto 2" />
            </div>
            <div className="sx-catalog-info">
              <h3>TOTEBAG VV</h3>
              <p>Bolsa de malla, print clásico.</p>
              <span className="sx-price">$250.00 MXN</span>
            </div>
          </div>

          {/* Producto 3 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion2_3.jpeg" alt="Producto 3" />
            </div>
            <div className="sx-catalog-info">
              <h3>TINTO AFRUTADO AG</h3>
              <p>Bebida cereza mexicana, 750 ml.</p>
              <span className="sx-price">$750.00 MXN</span>
            </div>
          </div>

          {/* Producto 4 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion24.jpeg" alt="Producto 4" />
            </div>
            <div className="sx-catalog-info">
              <h3>AG EFFERVESCENSE</h3>
              <p>Bebida cereza mexicana, 350 ml.</p>
              <span className="sx-price">$200.00 MXN</span>
            </div>
          </div>
        </div>
      </section>

      {/* ══ SECCIÓN 3: Catálogo de Productos ══ */}
      <section className="sx-product-catalog">
        <div className="sx-catalog-grid">
          {/* Producto 1 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion3_1.jpeg" alt="Producto 1" />
            </div>
            <div className="sx-catalog-info">
              <h3>T-Shirt OVERSIZE </h3>
              <p>Algodón, print clásico.</p>
              <span className="sx-price">$200.00 MXN</span>
            </div>
          </div>

          {/* Producto 2 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion3_2.jpeg" alt="Producto 2" />
            </div>
            <div className="sx-catalog-info">
              <h3>T-Shirt VV</h3>
              <p>Algodón, print clásico.</p>
              <span className="sx-price">$200.00 MXN</span>
            </div>
          </div>

          {/* Producto 3 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion3_3.jpeg" alt="Producto 3" />
            </div>
            <div className="sx-catalog-info">
              <h3>VELA AROMATICA </h3>
              <p>Vela temática, aroma cereza uva.</p>
              <span className="sx-price">$150.00 MXN</span>
            </div>
          </div>

          {/* Producto 4 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion3_4.jpeg" alt="Producto 4" />
            </div>
            <div className="sx-catalog-info">
              <h3>PRINT VV </h3>
              <p>Grabado artístico VV, 30 cm.</p>
              <span className="sx-price">$100.00 MXN</span>
            </div>
          </div>
        </div>
      </section>

      {/* ══ SECCIÓN 4: Catálogo de Productos ══ */}
      <section className="sx-product-catalog">
        <div className="sx-catalog-grid">
          {/* Producto 1 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion4_1.jpeg" alt="Producto 1" />
            </div>
            <div className="sx-catalog-info">
              <h3>Almohadón</h3>
              <p>Poliéster, print clásico.</p>
              <span className="sx-price">$200.00 MXN</span>
            </div>
          </div>

          {/* Producto 2 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion4_2.jpeg" alt="Producto 2" />
            </div>
            <div className="sx-catalog-info">
              <h3>Beanie black</h3>
              <p>Algodón, print clásico.</p>
              <span className="sx-price">$250.00 MXN</span>
            </div>
          </div>

          {/* Producto 3 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion4_3.jpeg" alt="Producto 3" />
            </div>
            <div className="sx-catalog-info">
              <h3>Vineyard hat</h3>
              <p>Poliéster, Lana.</p>
              <span className="sx-price">$450.00 MXN</span>
            </div>
          </div>

          {/* Producto 4 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <img src="/Seccion4_4.jpeg" alt="Producto 4" />
            </div>
            <div className="sx-catalog-info">
              <h3>Vineyard hat </h3>
              <p>Materiales tejidos.</p>
              <span className="sx-price">$250.00 MXN</span>
            </div>
          </div>
        </div>
      </section>

      <footer className="sx-footer">
        <div className="sx-footer-content">
          <span className="sx-copyright">
            Todo material y recursos fotográficos utilizados son propiedad
            exclusiva del Festival VV, MARCA REGISTRADA, queda prohibido su uso
            y descarga para otros fines de lucro, promoción y divulgación bajo
            responsabilidad legal.
          </span>
          <span className="sx-copyright">
            Festival VV — © Todos los derechos reservados.
          </span>
        </div>
      </footer>
    </div>
  );
};

const Experiencias = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [animar, setAnimar] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menuActivo, setMenuActivo] = useState(null);
  const cerrar = () => setMenuAbierto(false);

  const ejecutarAnimacionYLink = (url) => {
    setAnimar(true);
    setTimeout(() => {
      window.location.href = url;
    }, 800);
  };

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`sx-experiencias-page ${animar ? "efecto-salida" : ""}`}>
      <nav className={`sx-nav ${scrolled ? "scrolled" : ""}`}>
        <div className="cartier-header-main">
          <div className="cartier-logo-container">
            <Link to="/">
              <img
                src="/LogoHeader.png"
                alt="Cartier"
                className="cartier-logo-img"
              />
            </Link>
          </div>
          <Link to="/" className="sx-back-btn">
            ←
          </Link>
        </div>

        <div className="sx-nav-content">
          <div className="sx-menu">
            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("cartelera")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/cartelera" onClick={cerrar}>
                Cartelera
                <span
                  className={`sx-arrow ${
                    menuActivo === "cartelera" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${menuActivo === "cartelera" ? "show" : ""}`}
              >
                {/* El video de fondo */}
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="sx-dropdown-video"
                >
                  <source src="/Cartelera_Fondo.mp4" type="video/mp4" />
                  Tu navegador no soporta videos.
                </video>
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/sponsors" onClick={cerrar}>
                Sponsors
                <span
                  className={`sx-arrow ${
                    menuActivo === "sponsors" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "sponsors" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container sx-ocultar-movil"
              onMouseEnter={() => setMenuActivo("inicio")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/inicio" onClick={cerrar}>
                Inicio
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "inicio" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/accesorios" onClick={cerrar}>
                Accesorios
                <span
                  className={`sx-arrow ${
                    menuActivo === "accesorios" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "accesorios" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("experiencias")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/experiencias" onClick={cerrar}>
                Experiencias
                <span
                  className={`sx-arrow ${
                    menuActivo === "experiencias" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "experiencias" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>
          </div>

          <div className="sx-nav-right"></div>
        </div>
      </nav>

      <div className="sx-spacer" />
      <div></div>

      {/* ══ SECCIÓN 1 ══ */}
      <section className="sx-seccion4">
        <div className="sx-gallery-grid">
          <div className="sx-item">
            <a href="https://reinadelvino.com/" target="_blank">
              <img src="/Experiencia_Seccion_1.jpeg" alt="" />
            </a>
          </div>
        </div>
      </section>

      <div className="sx-experiencia-desc">
        <p>
          Conoce todas nuestras experiencias compartidas como{" "}
          <strong>Reina del Vino, The AG Gallery</strong> y por supuesto,
          alianzas con la comunidad local en la Región de los Tuxtlas.
        </p>
      </div>

      {/* ══ SECCIÓN 2 ══ */}

      <div className="sx-gallery-gridExp">
        <div className="sx-item">
          <a
            href="https://sanandrestuxtla.gob.mx/turismo-hoteles/"
            target="_blank"
          >
            <img src="/Experiencia_Seccion_2_Img1.jpeg" alt="" />
          </a>

          <div className="sx-item-info">
            <h3>HOSPEDAJES</h3>
            <p>
              Conoce los mejores lugares para hospedarte en la región, desde el
              tradicional Hotel del Parque a opciones como Hoteles Piedra Alta,
              La Finca, OYO, entre otros.
            </p>
          </div>
        </div>

        <div className="sx-item">
          <a href="https://cactuscine.com" target="_blank">
            <img src="/Experiencia_Seccion_2_Img2.jpeg" alt="" />
          </a>

          <div className="sx-item-info">
            <h3>FILM EL MAESTRO DEL VINO 3</h3>
            <p>
              Descubre el film internacional para Amazon Prime del que somos
              parte junto a Bodega AG, disfruta las funciones y sorpresas.
            </p>
          </div>
        </div>

        <div className="sx-item">
          <a
            href="https://programadestinosmexico.com/que-ver-y-hacer-en-los-tuxtlas/"
            target="_blank"
          >
            <img src="/Experiencia_Seccion_2_Img3.jpeg" alt="" />
          </a>

          <div className="sx-item-info">
            <h3>RECOMENDACIONES</h3>
            <p>
              No te olvides de visitar lugares de encanto como el Mesón de
              Santiago, en Santiago Tuxtla, prueba el licor de Xoxogo y la
              comida nativa de la zona, sur del estado de Veracruz.
            </p>
          </div>
        </div>
      </div>

      <footer className="sx-footer">
        <div className="sx-footer-content">
          <span className="sx-copyright">
            Todo material y recursos fotográficos utilizados son propiedad
            exclusiva del Festival VV, MARCA REGISTRADA, queda prohibido su uso
            y descarga para otros fines de lucro, promoción y divulgación bajo
            responsabilidad legal.
          </span>
          <span className="sx-copyright">
            Festival VV — © Todos los derechos reservados.
          </span>
        </div>
      </footer>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<AGIndustries />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/cartelera" element={<Cartelera />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/inicio" element={<AGIndustries />} />
        <Route path="/accesorios" element={<Accesorios />} />
        <Route path="/experiencias" element={<Experiencias />} />
      </Routes>
    </Router>
  );
}

export default App;
